import { getEventDetails } from '@store/slices/eventSlice';
import { SessionsRoot, Underline, TitleText } from './styles';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import SessionInfoItem from './SessionInfoItem';

// Interface based on actual session data structure
export interface SessionItem {
  session_id: string;
  start_date: string;
  end_date: string;
  title: string;
  sub_title?: string;
  description: string;
  type: string;
  location: string;
  location_name: string;
  location_description?: string;
  // Keeping city for backward compatibility
  city?: string;
}

const Sessions = ({
  sessions,
  injectSessionDescription = false,
}: {
  sessions?: SessionItem[];
  injectSessionDescription?: boolean;
}) => {
  const { t } = useTranslation();
  const sluggedEvent = useSelector(getEventDetails)?.[0];

  if (!sessions?.length) return null;

  return (
    <SessionsRoot>
      <TitleText color={sluggedEvent?.design?.headerFontColor}>
        {t('sessions')}
      </TitleText>
      <Underline color={sluggedEvent?.design?.themeColor} />

      {sessions?.map((sessionItem: SessionItem) => {
        return (
          <SessionInfoItem
            key={
              sessionItem.session_id ||
              `${sessionItem.start_date}-${sessionItem.location}`
            }
            item={sessionItem}
            injectSessionDescription={injectSessionDescription}
          />
        );
      })}
    </SessionsRoot>
  );
};

Sessions.displayName = 'Sessions';

export default Sessions;
